var map = {
	"./facebook.png": 61247,
	"./instagram.png": 89730,
	"./line.png": 88020,
	"./linkedin.png": 73966,
	"./pinterest.png": 80207,
	"./skype.png": 87129,
	"./telegram.png": 88926,
	"./twitter.png": 22296,
	"./wechat.png": 8336,
	"./whatsapp.png": 11932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43141;